import { EmailAuthProvider, GoogleAuthProvider } from "firebase/auth";

// Configure FirebaseUI.
const uiConfig = {
	// Popup signin flow rather than redirect flow.
	signInFlow: "popup",
	// Redirect to /signedIn after sign in is successful. Alternatively you can provide a callbacks.signInSuccess function.
	signInSuccessUrl: "#/",
	// We will display Google and Facebook as auth providers.
	signInOptions: [
		EmailAuthProvider.PROVIDER_ID,
		GoogleAuthProvider.PROVIDER_ID,
		// firebase.auth.FacebookAuthProvider.PROVIDER_ID,
		// firebase.auth.PhoneAuthProvider.PROVIDER_ID,
	],
	credentialHelper: "none",
};

export default uiConfig;
